import { gql } from '@apollo/client';

import { ContributorFragment } from './Contributor.graphql';
import { AscProjectMonthPerContributorFragment } from './ProjectMonthPerContributor.graphql';

/**
 * This is a fragment used to encapsulate the fields used when querying for a contributor plus its relations.
 */
export const GetContributorFragment = gql`
  fragment GetContributor on Contributor {
    ...Contributor
    ascProjectsPerContributor(fiscalYearId: $fiscalYearId, periodName: $periodName) {
      id
      ascProject {
        id
        name
      }
      ascProjectMonthsPerContributor {
        ...AscProjectMonthPerContributor
      }
    }
  }
  ${ContributorFragment}
  ${AscProjectMonthPerContributorFragment}
`;
